export const pageViewCompleteEvent = () => {
    setTimeout(() => {
        window.appEventData = window.appEventData || [];
        window.appEventData.push({ event: 'Page Load Completed' });
    }, 250);
};
